import * as React from "react";
import type { StoryMeta } from "@features/devtools/registry/types";
// Vite raw import to read markdown content as string
// eslint-disable-next-line import/no-webpack-loader-syntax
import devtoolsMd from "../../../../docs/devtools.md?raw";

function DocsView({ content }: { content: string }) {
  return (
    <div className="prose prose-sm max-w-none dark:prose-invert">
      <pre className="whitespace-pre-wrap text-xs leading-relaxed p-3 bg-muted rounded border">
        {content}
      </pre>
    </div>
  );
}

type Props = React.ComponentProps<typeof DocsView>;

const meta: StoryMeta<Props> = {
  id: "devtools/Guide",
  title: "Devtools Guide",
  group: "Docs",
  component: DocsView as any,
  description: "In-app guide for the Devtools module (storybook-lite).",
  defaultProps: { content: devtoolsMd },
  controls: {
    content: { type: "code", label: "Markdown" },
  },
};

export default meta;
